var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.acceptData && _vm.acceptData.length > 0)?_c('div',[(_vm.isList)?_c('List',{attrs:{"itemData":_vm.acceptData}}):_c('Single',{attrs:{"itemData":_vm.acceptData}})],1):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-d9bf38d6","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/expertInfo/index.vue
// module id = null
// module chunks = 